export const businessRateAward = {
  name: 'BusinessRate Top 10 Award Winner 2026',
  headline: 'Top Publisher in Los Angeles County',
  issuer: 'BusinessRate',
  issuerUrl: 'https://businessrate.com/awards',
  dateAwarded: 'October 9, 2026',
  dateAwardedISO: '2026-10-09',
  category: 'Top Publisher',
  region: 'Los Angeles County, California',
  basis: 'Verified customer feedback and publicly available Google review data',
  dataset: 'More than 26 million businesses and 1.7 billion reviews compiled over 18 years',
  awardCode: '4YNNU5',
  signatory: 'Kyle Pittman, Founder & President, BusinessRate',
  letterImage:
    'https://storage.helloreaddy.io/project_files/d4a3ff26-933b-4c2f-85e6-4a8de0cf4dd2/9aa6d43f-57b2-4f66-a995-7e0d50054ec6_compressed_BusinessRate-2026-Award-Letter.webp',
  letterAlt:
    "BusinessRate Top 10 2026 Award Winner letter addressed to the Leavitt Peak Press team, naming Leavitt Peak Press a Top Publisher in Los Angeles County for 2026 based on Google reviews, dated October 9, 2026",
};